// ============================================
// SELECTORFAMILIA.JS — "¿de qué es este trabajo?"
// ============================================
// CATALOGO-FAMILIAS (2026-09-24). El mismo desplegable en los dos sitios donde hace
// falta: al dar de alta un expediente y al editar un servicio del catalogo. Que sea el
// MISMO componente no es capricho — si las dos pantallas ofrecieran listas distintas, un
// expediente de 'computo' nunca encontraria los servicios de 'computo'.
//
// PARA QUE SIRVE, en una linea: de aqui sale que servicios se ofrecen arriba al cotizar
// desde ese expediente, y que cotizaciones viejas se consideran parecidas.
//
// DEJARLO VACIO ES UNA RESPUESTA VALIDA, y por eso la opcion existe y se llama "Se deduce
// sola". Cuando esta vacio, el sistema lo adivina del titulo; en cuanto alguien elige, la
// eleccion manda. Obligar a elegir en el alta solo conseguiria que la gente marque lo
// primero con tal de seguir.

import React from 'react';
import useFamilias from '../hooks/useFamilias';

const PP = "'Poppins', sans-serif";
const BORDE = '#e6e8ea';
const GRIS_CLARO = '#9aa3ab';

export default function SelectorFamilia({
  valor,
  onChange,
  etiqueta = 'Tipo de trabajo',
  ayuda = null,
  deshabilitado = false,
  estilo = {},
}) {
  // RUBROS (2026-10-16): la lista sale del hook compartido (misma cache que el filtro por rubro).
  const familias = useFamilias();

  return (
    <div style={{ fontFamily: PP, ...estilo }}>
      {etiqueta && (
        <div style={{ fontSize: 12, fontWeight: 600, color: '#5e666e', marginBottom: 4 }}>
          {etiqueta}
        </div>
      )}
      <select
        value={valor || ''}
        disabled={deshabilitado}
        onChange={e => onChange(e.target.value || null)}
        style={{
          width: '100%', boxSizing: 'border-box', minHeight: 44, padding: '10px 12px',
          borderRadius: 10, border: `1px solid ${BORDE}`, fontFamily: PP, fontSize: 14,
          background: deshabilitado ? '#f4f5f6' : '#fff', color: valor ? '#2e3338' : GRIS_CLARO,
        }}
      >
        <option value="">Se deduce sola (del título)</option>
        {familias.map(f => (
          <option key={f.id} value={f.id}>{f.etiqueta}</option>
        ))}
      </select>
      {ayuda !== null ? ayuda : (
        <div style={{ fontSize: 11.5, color: GRIS_CLARO, marginTop: 4, lineHeight: 1.4 }}>
          Decide qué servicios se ofrecen primero al cotizar. Déjalo vacío si el título ya lo dice.
        </div>
      )}
    </div>
  );
}
